export default "__VITE_ASSET__c2655cea__"